var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.656,
    height: 28.852,
    viewBox: "0 0 28.656 28.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_menu_1166837",
    transform: "translate(-13.5 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M33.147,48.795h17.53a2.166,2.166,0,0,0,2.147-2.147h0A2.166,2.166,0,0,0,50.677,44.5H33.147A2.166,2.166,0,0,0,31,46.647h0A2.141,2.141,0,0,0,33.147,48.795Z",
    transform: "translate(-10.668 -19.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M52.547,80.195h9.917a2.166,2.166,0,0,0,2.147-2.147h0A2.166,2.166,0,0,0,62.464,75.9H52.547A2.166,2.166,0,0,0,50.4,78.047h0A2.141,2.141,0,0,0,52.547,80.195Z",
    transform: "translate(-22.494 -38.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M15.647,17.295H40.009a2.166,2.166,0,0,0,2.147-2.147h0A2.166,2.166,0,0,0,40.009,13H15.647A2.166,2.166,0,0,0,13.5,15.147h0A2.141,2.141,0,0,0,15.647,17.295Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.f2c47644ae7384c32a0dadce23771ce0.svg";
export { ForwardRef as ReactComponent };